module.exports = __webpack_public_path__ + "img/partners@2x.0a4a0ee.webp";